/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

module misc {
  'use strict';
  
  var carrusel = angular.module('carrusel', ['navigation'])
    .controller('HomeCarruselCtrl', HomeCarruselCtrl)
    .directive('preloaderBg', carrouselPreloaderDirective);

  var sigristHistory = angular.module('sigrist-history', ['photometerdirective', 'ngSanitize'])
    .controller('SigristHistoryCtrl', SigristHistoryCtrl);

  var photometerfilter =  angular.module('photometerfilter', [])
    .filter('advancedNumber', AdvancedNumberFilter);

  var photometerdirective = angular.module('photometerdirective', [])
    .directive('jsonData', jsonDataDirective);

  var imagelazyload = angular.module('imagelazyload', [])
    .directive('imageLazyLoad', imageLazyLoadDirective);

  var youTubeOverlay = angular.module('youTubeOverlay', [])
    .directive('youTubeOverlay', youTubeOverlayDirective);

  var editableContent = angular.module('editableContent', [])    
  .directive('editableContent', misc.EditableContentDirective)


}